import { ChangeDetectionStrategy, Component, effect, inject, Input, signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';

import { Store } from '@ngrx/store';

import { selectChannelsFilter } from '../../../../../store/app.selectors';
import { BaseComponent } from '../../../../shared/components/base/base.component';
import { setAllChannelsLoaded, setLoadingChannels } from '../../../../shared/store/ui.actions';
import { IFilters, WorkspaceFeatures } from '../../../interfaces/IWorkspace';
import { PermissionsService } from '../../../services/permissions.service';
import {
  getUnreadMessages,
  loadChannels,
  setChannels,
  setChannelsFilter,
  setFilterValue,
} from '../../../store/chat.actions';
import { AppStateWithChat, chatInitialState } from '../../../store/chat.reducer';

@Component({
  selector: 'ngx-selector-filter',
  templateUrl: './selector-filter.component.html',
  styleUrls: ['./selector-filter.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class SelectorFilterComponent extends BaseComponent {
  @Input() selector: IFilters;

  private store = inject(Store<AppStateWithChat>);
  private permissionService = inject(PermissionsService);

  channelsFilter = toSignal(this.store.select(selectChannelsFilter), { initialValue: chatInitialState.channelsFilter });
  filterName = signal<string | boolean>('');

  constructor() {
    super();
    effect(() => {
      this.syncFilterName();
    });
  }

  setValue(value: string | boolean): void {
    this.store.dispatch(setFilterValue({ value, key: this.selector.name }));
    this.store.dispatch(setAllChannelsLoaded({ value: false }));
    this.store.dispatch(setChannelsFilter({ filter: { ...this.channelsFilter(), page: 1 } }));
    if (!this.selector.isManualFilter) {
      this.store.dispatch(setChannels({ channels: [], concat: false }));
      this.store.dispatch(setLoadingChannels({ value: true }));
      this.store.dispatch(
        loadChannels({
          autoSelectChannel: false,
          setLoading: true,
          concat: false,
        })
      );
    }
    this.filterName.set(value || this.selector.name);
    if (this.permissionService.checkWorkspaceFeatures([WorkspaceFeatures.showUnreadsCounter])) {
      this.store.dispatch(getUnreadMessages());
    }
  }

  private syncFilterName(): void {
    if (this.selector?.value === null || this.selector?.value === undefined) {
      this.filterName.set(this.selector?.name ?? '');
      return;
    }
    this.filterName.set(
      this.selector?.options?.find((option) => option.value === this.selector?.value)?.name ?? this.selector?.name ?? ''
    );
  }
}
